// covered-by: frontends/carrie/src/ask-v2/home/__tests__/AskV2Home.test.tsx
import { type AskPunttBriefing } from "@mg/schemas/src/christo/askPunttBriefing";
import { Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { briefingGreetingText, greetingNameSuffix } from "./greeting";

type BriefingHeaderProps = {
  briefing: AskPunttBriefing | undefined;
  userName: string | undefined;
  failed: boolean;
};

export function BriefingHeader({
  briefing,
  userName,
  failed,
}: BriefingHeaderProps) {
  const { t } = useTranslation("ui");
  const serverGreeting = briefingGreetingText(briefing);
  const greeting =
    serverGreeting ??
    t("askV2.home.greeting", { name: greetingNameSuffix(userName) });

  return (
    <header
      data-testid="ask-v2-briefing-header"
      className="flex flex-col gap-2"
    >
      <Heading as="h2" size="5" data-testid="ask-v2-greeting">
        {greeting}
      </Heading>
      {failed ? (
        <Text as="p" size="2" color="red" data-testid="ask-v2-briefing-failed">
          {t("askV2.home.briefingFailed")}
        </Text>
      ) : null}
      {briefing ? (
        <>
          <Text as="p" size="2" color="gray" data-testid="ask-v2-prep">
            {t("askV2.home.prep", {
              assets: briefing.prep.assetsRead,
              approvals: briefing.prep.approvalFilesRead,
            })}
          </Text>
          <Text as="p" size="2" color="gray" data-testid="ask-v2-findings">
            {t("askV2.home.findings", {
              settle: briefing.findings.youCanSettle,
              experts: briefing.findings.forExperts,
              unsure: briefing.findings.unsure,
            })}
          </Text>
          {briefing.guarantee.acted === false ? (
            <Text as="p" size="2" data-testid="ask-v2-changed-nothing">
              {t("askV2.home.changedNothing")}
            </Text>
          ) : null}
        </>
      ) : null}
    </header>
  );
}
